import { createAsyncThunk } from '@reduxjs/toolkit';
import { getStarredCandidates, getTagsOptions } from 'util/Api/user';

export const fetchStarredCandidates = createAsyncThunk(
  'candidate/getStarredCandidates',
  async ({ pageNumber, itemsPerPage, sort, filter }, { rejectWithValue }) => {
    try {
      return await getStarredCandidates({ pageNumber, itemsPerPage, sort, filter });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const fetchStarredTagsOptions = createAsyncThunk(
  'candidate/fetchStarredTagsOptions',
  async ({ pageNumber, searchValue }, { rejectWithValue }) => {
    try {
      return await getTagsOptions({ pageNumber, searchValue });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
